module.exports = __webpack_public_path__ + "c472a87156d8365ea8af1a7d75ca4460.woff2";